import React from "react";

const ConfInviteItem = (props) => {
    const { l, invitee, index } = props;

    return <li className="emailListItem" key={`${index}-${invitee.email}`}>
        <div className="emailAvtr">
            <img src="/images/icons/default-user.png" className="invertGray" alt="user-icon" />
        </div>
        <div className="emailTxtBox">
            <span>{invitee.email}</span>
        </div>
        <div className="sendBtnBox" onClick={() => { if (!invitee.sent) props.handleInvitation(index) }}>
            {invitee.sending ? <span>{l.inv_sending}</span> :
                <span>{invitee.sent ? l.inv_sent : l.invite}</span>}

        </div>
    </li>

}

export default React.memo(ConfInviteItem);